import { Component, computed, input, linkedSignal, model, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-input-count',
  imports: [],
  templateUrl: './input-count.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './input-count.css',
})
export class InputCount {
  titulo = input<string>();
  cantidad = model<number>(1);
  min = input<number>(0);
  max = input<number>(9999999);
  step = input<number>(1);
  decimal = input<boolean>(false);

  private readonly catalizador = computed(() => ({
    cantidad: this.cantidad(),
    min: this.min(),
    max: this.max(),
    decimal: this.decimal(),
  }));

  cantidadFinal = linkedSignal({
    source: () => this.catalizador(),
    computation: (source) => {
      const bounded = Math.min(Math.max(source.cantidad, source.min), source.max).toFixed(
        source.decimal ? 2 : 0,
      );
      return parseFloat(bounded);
    },
  });
  private normalize(val: number) {
    let newValue = val;

    if (newValue < this.min()) newValue = this.min();
    if (newValue > this.max()) newValue = this.max();

    if (!this.decimal()) newValue = Math.round(newValue);
    else newValue = parseFloat(newValue.toFixed(2));

    return newValue;
  }

  setValue(val: number) {
    const normalized = this.normalize(val);
    this.cantidadFinal.set(normalized);
    this.cantidad.set(normalized); // Notificar al padre
  }

  decrementar() {
    this.setValue(this.cantidadFinal() - this.step());
  }

  incrementar() {
    this.setValue(this.cantidadFinal() + this.step());
  }

  onCantidadChange(event: Event) {
    const inputEl = event.target as HTMLInputElement;
    const value = parseFloat(inputEl.value);
    this.setValue(isNaN(value) ? this.min() : value);
  }
}
